import type { IconTypes } from '@ecomm/shared-icons'
import { ConfidenceItem } from './ConfidenceItem'

type Props = {
  readonly listItems: readonly {
    readonly disclaimer?: string
    readonly headline: string
    readonly icon: IconTypes
  }[]
  readonly key?: string
}

/**
 * Confidence Bar component
 * @param listItems - The list of items to display in the confidence bar
 * @returns JSX.Element
 */
export function ConfidenceBar({ listItems }: Props) {
  return listItems.length > 0 ? (
    <ul
      className="list-none p-0 m-0 flex flex-row flex-wrap gap-4 lg:flex-nowrap lg:gap-8"
      data-testid="ConfidenceBar"
    >
      {listItems.map(item => (
        <ConfidenceItem key={`item-${item.headline}`} {...item} />
      ))}
    </ul>
  ) : null
}
